import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useRirekishoFormatData } from '@/composables/format-edit/useRirekishoFormatData'

type FormLibWithCharCount = {
  charCount: (value: string | undefined) => number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RirekishoOthersCard',
  props: {
    currentCardId: null,
    formatId: null,
    optionItems: null
  },
  setup(__props: any) {



const { formLib: formLibRaw } = useHostServices()
const formLib = formLibRaw as typeof formLibRaw & FormLibWithCharCount
const formatData = useRirekishoFormatData()

const commuteDescriptionOverLimit = computed(
  () => formLib.charCount(formatData.commuteDescription) > 84
)

return { __sfc: true,formLibRaw, formLib, formatData, commuteDescriptionOverLimit }
}

})